import axios from 'axios';
import { route } from 'ziggy-js';

export class OrderMatrix {
    init(params = {}) {
        this.load(params);
    }

    async load(params = {}) {
        const { modelno }        = document.querySelector('.product').dataset;
        const orderMatrixWrapper = document.querySelector('.ordermatrix-wrapper');

        if (orderMatrixWrapper) {
            const apiResponse = await axios.get(route('catalog.ordermatrix', { modelNo: modelno }), {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                params: params.query
            });

            orderMatrixWrapper.innerHTML = apiResponse.data;

            document.dispatchEvent(new CustomEvent('order-matrix-loaded', { modelNo: modelno }));

            update_shoppingcart();
        }
    }
}
